import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, OnInit } from '@angular/core';
import { SLLayer } from 'src/app/model/sl-layer';
import { SnapLayer } from 'src/app/model/virutal-layers/snap-layer';
import * as turf from '@turf/turf';
import { MapService } from 'src/app/services/map.service';
import { SnapLayerAPIService } from 'src/app/model/api-services/snap-layer-api.service';
import { SLMap } from 'src/app/model/sl-map';
import { ISLMap } from 'src/app/types/@types/sl-map';
import { InterruptableTimer } from 'src/app/model/interruptabletimer';

@Component({
  selector: 'app-snap-layer-view',
  templateUrl: './snap-layer-view.component.html',
  styleUrls: ['./snap-layer-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SnapLayerViewComponent implements OnInit {
  public name = 'Snap Layer';
  public back = new EventEmitter<{ layer: SLLayer }>();
  public layer?: SnapLayer;
  private _opacity: number = 100;
  public loaded = false;
  public set opacity(val: number) {
    if (this._opacity === val) return;
    if (!!this.layer) {
      this.layer.opacity = val;
    }
    this._opacity = val;
    this.cdr.markForCheck();
    this.cdr.detectChanges();


  }
  public get opacity(): number {
    return this.layer?.opacity ? this.layer.opacity : this._opacity;
  }

  public bbox: Array<number> = [];
  private _bufferDistance = 0;
  public set bufferDistance(val: number) {
    if (this._bufferDistance === val) return;
    this._bufferDistance = val;
    MapService.Get().snapLayerService.SetBufferDistance(val);
    MapService.Get().snapLayerService.RefreshSnaps();
  }
  public get bufferDistance(): number {
    return this._bufferDistance;
  }
  private _visibility = true;

  private _snapPtVis: boolean = true;
  public set snapPtVis(val: boolean) {
    this._snapPtVis = val;
    this.UpdateVis()
  }
  public get snapPtVis(): boolean {
    return this._snapPtVis;

  }
  private _snapSegVis: boolean = true;
  public set snapSegVis(val: boolean) {
    this._snapSegVis = val;
  }

  public get srcLayer(): SLLayer {
    return this.layer.sourceLayer;
  }
  public set sourceVis(vis: boolean) {
    if (!this.srcLayer) return;
    this.srcLayer.layerOn = vis;
  }
  public get sourceVis(): boolean {
    if (!this.srcLayer) return false;
    return this.srcLayer.layerOn;
  }


  public set drawVis(vis: boolean) {
    if (!this.srcLayer?.map?.digitizer?.drawPane?.GetSelectedFeature()) return;
    this.srcLayer.map.digitizer.drawPane.GetSelectedFeature().ToggleVis(vis);
  }
  public get drawVis(): boolean {
    return this.srcLayer?.map?.digitizer?.drawPane?.GetSelectedFeature().GetVis();
  }

  private _autoReload
  public set autoReload(val: boolean) {
    this._autoReload = val;

  }
  public get autoReload() {
    return this._autoReload;
  }
  constructor(private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.bufferDistance = 100;
  }
  UpdateVis() {

  }
  SetupBuffer() {
  }
  private map: ISLMap;
  private timer: InterruptableTimer = new InterruptableTimer(200);
  ShowLayer(layer: SLLayer, node: any, view: SnapLayerViewComponent) {
    this.layer = layer as SnapLayer;
    this.layer.opacity = this._opacity;
    this.loaded = true;
    this.cdr.detectChanges();
    if (!this.map) this.SetupMap();


  }
  SetupMap() {
    this.map = this.layer.map;
    this.map.ui.on('idle', () => {
      if (!this._autoReload) return;
      this.timer.Start(() => {
        if (!this._autoReload) return;
        this.ReloadSnaps();
      })
    })
  }
  HandleOpacityChange(opacity: number) {
    this.opacity = opacity;
  }

  ReloadSnaps() {
    MapService.Get().snapLayerService.RefreshSnaps();
  }
  Back() {
    this.back.emit({ layer: this.layer });
  }
}
